module.exports = __webpack_public_path__ + "static/media/ios-badge-white@3x.1d7e01df.png";